import { PermanentCandidatesAlertsFilterEnum } from 'src/app/accountmanagers/perm-post-offer/enums/permanent-candidates-alerts.enum';
import { PermanentJobOfferDashboardStatusEnum } from 'src/app/accountmanagers/perm-post-offer/enums/permanent-job-offer-dashboard-status.enum';
import { FetchArgs } from 'src/app/shared/models/core';
export class PermCandidatesGridFilter {
    accountManagerId?: number;
    jobId?: number;
    candidateFullName: string;
    facilityName: string;
    showAMFacilitiesOnly: boolean;
    billingAmountFrom?: number;
    billingAmountTo?: number;
    discountedBillingAmountFrom?: number;
    discountedBillingAmountTo?: number;
    submittedDateTo?: Date | string;
    submittedDateFrom?: Date | string;
    offerDateTo?: Date | string;
    offerDateFrom?: Date | string;
    startDateTo?: Date | string;
    startDateFrom?: Date | string;
    permanentJobOfferIds?: number[];
    systemName: string;
    recruiterFullName: string;
    accountManagerFullName: string;
    daysToOfferTo?: number;
    daysToOfferFrom?: number;
    alertsFilter: PermanentCandidatesAlertsFilterEnum[];
    jobOfferStatusId?: PermanentJobOfferDashboardStatusEnum;
    recruiterBonusFrom?: number;
    recruiterBonusTo?: number;
    [key: string]: any;
}

export interface PermCandidatesGridFetchArgs extends Omit<FetchArgs, 'filter'> {
    filter?: PermCandidatesGridFilter;
}

const deserializeDateInFilter = (date: string | undefined): Date | string | undefined => {
    if (typeof date === 'string') {
        const parsedDate = new Date(date);
        return isNaN(parsedDate.getTime()) ? date : parsedDate;
    }
    return date;
};

export const deserializeFilter = (
    filter: PermCandidatesGridFilter | undefined
): PermCandidatesGridFilter | undefined => {
    if (!filter) {
        return undefined;
    }

    return {
        ...filter,
        submittedDateTo: deserializeDateInFilter(filter.submittedDateTo as string),
        submittedDateFrom: deserializeDateInFilter(filter.submittedDateFrom as string),
        offerDateTo: deserializeDateInFilter(filter.offerDateTo as string),
        offerDateFrom: deserializeDateInFilter(filter.offerDateFrom as string),
        startDateTo: deserializeDateInFilter(filter.startDateTo as string),
        startDateFrom: deserializeDateInFilter(filter.startDateFrom as string)
    };
};

const serializeDateInFilter = (date: Date | string | undefined): string | undefined => {
    if (date instanceof Date) {
        return date.toJSON();
    }
    return date;
};

export const serializeFilter = (filter: PermCandidatesGridFilter | undefined): PermCandidatesGridFilter | undefined => {
    if (!filter) {
        return undefined;
    }

    return {
        ...filter,
        submittedDateTo: serializeDateInFilter(filter.submittedDateTo),
        submittedDateFrom: serializeDateInFilter(filter.submittedDateFrom),
        offerDateTo: serializeDateInFilter(filter.offerDateTo),
        offerDateFrom: serializeDateInFilter(filter.offerDateFrom),
        startDateTo: serializeDateInFilter(filter.startDateTo),
        startDateFrom: serializeDateInFilter(filter.startDateFrom)
    };
};
